module.exports = __webpack_public_path__ + "static/media/down.282589c7.svg";